import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { UserTimeSheetService } from 'src/app/services/user-time-sheet.service';
import { UtilityService } from 'src/app/services/utility.service'
import { FileUploaderService } from 'src/app/services/file-uploader.service';
import { AssetService } from 'src/app/services/asset.service';
import { UserRoleService } from 'src/app/services/user-role.service';
import { JobService } from 'src/app/services/jobs/job.service';
import { shiftInfo } from 'src/app/_models/staticArray';
import { CalculationService } from '../../../services/calculation.service';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { payRates } from '../../../_models/staticArray';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'app-job-hours-model',
  templateUrl: './job-hours-model.component.html',
  styleUrls: ['./job-hours-model.component.scss']
})
export class JobHoursModelComponent implements OnInit {
  jobHrsForm: FormGroup;
  loading: boolean = false;
  updated: boolean;
  hoursValid: boolean = true;
  hoursValid1: boolean = true;
  hoursValid2: boolean = true;
  startValid: boolean = true;
  endValid: boolean = true;
  isError: boolean = false;
  modelTitle: string;
  newFiles: any;
  files = [];
  deletedFiles: any = [];
  enableSave: boolean;
  cpdfiles: any;
  queue: any;
  placeholder: string;
  user: any;
  isStaff: boolean = false
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  shiftInformation = shiftInfo
  isDifference = false
  isDisable = false
  _startTimeNotValid = false
  _endTimeNotValid = false
  _isControlDisable = true
  _isExpenseControlDisable = true
  _isDeductionControlDisable = true
  totalWorkingHours = 0
  totalTravelWorkingHours = 0
  selectedIndex
  userId
  removeExpenses = []
  payRates = payRates
  userRole
  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<any>,
    private _userTimeSheetServices: UserTimeSheetService,
    private _snackBar: MatSnackBar,
    private _utilityServices: UtilityService,
    public dialog: MatDialog,
    public uploader: FileUploaderService,
    public _assetService: AssetService,
    public _jobService: JobService,
    public _userRoleService: UserRoleService,
    public _calculationService: CalculationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.userRole = JSON.parse(localStorage.getItem('userRoles'))
    if (this.data && this.data.isDisable) this.isDisable = this.data.isDisable
    console.log("data get in model", this.data, this.isDisable);
    this.user = JSON.parse(localStorage.getItem('currentUser'))
    if (this.user && this.user.userRole && this.user.userRole.includes('admin')) this.userId = this.user._id
    else this.userId = this.user.userId
    this.queue = this.uploader.queue;
    // this.queue.subscribe(res => {
    //   console.log("%c SOMETHING CHANGED IN QUEUE=====>>>>>", "color:red", res);
    //   if (res.length == 0) {
    //     this.enableSave = true
    //   }
    //   else {
    //     this.enableSave = false
    //   }
    // })
    if (this.data.isInstructor) {
      this.modelTitle = 'Edit Timelog'
      this.placeholder = "Details"
    } else if (this.data.isStaff) {
      this.modelTitle = 'CPD Calender'
      this.placeholder = "Details of CPD Complete"
    } else {
      this.modelTitle = ' Off the Job Hours'
      this.placeholder = "Details of Work Complete"
    }

    if (this.data.files)
      this.files = this.data.files
    console.log("this.files in job model", this.files);


    this.createForm(this.data)
    if (this.data && this.data.type === 'OTJH') this.getUserRole();
  }
  getUserRole() {
    this._jobService.getJobById(this.data.jobId).subscribe((job) => {
      console.log("job.......", job);
      let getRole = this._userRoleService.getUserRole(job.data[0].instructors, 'job');

      if (getRole.isAdmin) this.isAdmin = true
      else if (getRole.isLearner) this.isLearner = true
      else if (getRole.isTrainer) this.isTrainer = true
      else if (getRole.isIQA) this.isIQA = true
    })
  }


  // CREATE FORM
  createForm(data?) {
    console.log("data in createForm()", data.data.value);
    if (data.isInstructor) {
      this.jobHrsForm = this.formBuilder.group({
        name: new FormControl(data && data.name ? data.name : ''),
        hoursWorked: new FormControl((data && data.data && data.data.value && data.data.value.workingHours) ? data.data.value.workingHours : '', Validators.required),
        details1: new FormControl((data && data.data && data.data.value && data.data.value.extraDetails) ? data.data.value.extraDetails : ''),
        details2: new FormControl((data && data.data && data.data.value && data.data.value.other) ? data.data.value.other : ''),
        date: new FormControl((data && data.data && data.data.value && data.data.value.date) ? new Date(moment(data.data.value.date, 'DD/MM/YYYY').format('MM/DD/YYYY')) : ''),
        start: new FormControl((data && data.data && data.data.value && data.data.value.start) ? data.data.value.start : ''),
        end: new FormControl((data && data.data && data.data.value && data.data.value.end) ? data.data.value.end : ''),
        job: new FormControl((data && data.data && data.data.value && data.data.value.job) ? data.data.value.job : null),
        projectCode: new FormControl((data && data.data && data.data.value && data.data.value.projectCode) ? data.data.value.projectCode : ''),
        shiftInfo: new FormControl((data && data.data && data.data.value && data.data.value.shiftInfo) ? data.data.value.shiftInfo : ''),
        travel: new FormControl((data && data.data && data.data.value && data.data.value.travel) ? data.data.value.travel : ''),
        // nightAway: new FormControl((data && data.data && data.data.value && data.data.value.nightAway) ? data.data.value.nightAway : ''),
        totalHours: new FormControl((data && data.data && data.data.value && data.data.value.totalHours) ? data.data.value.totalHours : ''),
        livingAllowance: new FormControl((data && data.data && data.data.value && data.data.value.livingAllowance) ? data.data.value.livingAllowance : false),
        expense: new FormControl((data && data.data && data.data.value && data.data.value.expense) ? data.data.value.expense : false),
        deduction: new FormControl((data && data.data && data.data.value && data.data.value.deduction) ? data.data.value.deduction : false),
        multipleLogs: this.formBuilder.array(this.addMultipleLogs((data && data.data && data.data.value && data.data.value.multipleLogs) ? data.data.value.multipleLogs : [])),
        multipleExpenses: this.formBuilder.array(this.addMultipleExpenses((data && data.data && data.data.value && data.data.value.multipleExpense) ? data.data.value.multipleExpense : [])),
        multipleDeduction: this.formBuilder.array(this.addMultipleDeduction((data && data.data && data.data.value && data.data.value.multipleDeduction) ? data.data.value.multipleDeduction : [])),
        payRate: new FormControl((data && data.data && data.data.value && data.data.value.payRate) ? data.data.value.payRate : ''),
        paidHours: new FormControl((data && data.data && data.data.value && data.data.value.paidHours) ? data.data.value.paidHours : ''),
      })
      this.jobHrsForm.get('date').disable()
    } else {
      console.log("CALL THIS ELSE PART OF FORM")
      this.jobHrsForm = this.formBuilder.group({
        weekNumber: new FormControl((data && data.data && data.data.value && data.data.value.weekNumber) ? data.data.weekNo : ''),
        weekStartDate: new FormControl((data && data.data && data.data.value && data.data.value.weekStartDate) ? new Date(data.data.value.weekStartDate) : ''),
        weekEndDate: new FormControl((data && data.data && data.data.value && data.data.value.weekEndDate) ? new Date(data.data.value.weekEndDate) : ''),
        hoursWorked: new FormControl((data && data.data && data.data.value && data.data.value.workingHours) ? data.data.value.workingHours : '', Validators.required),
        details1: new FormControl((data && data.data && data.data.value && data.data.value.extraDetails) ? data.data.value.extraDetails : ''),
        details2: new FormControl((data && data.data && data.data.value && data.data.value.other) ? data.data.value.other : ''),
      })
      this.jobHrsForm.get('weekNumber').disable()
      this.jobHrsForm.get('weekStartDate').disable()
      this.jobHrsForm.get('weekEndDate').disable()
    }
    console.log("AFTER CREATING FORM VALUE", this.jobHrsForm.value)
    this.changeFormValue()
  }


  get multipleLogsList() { return this.jobHrsForm.get('multipleLogs') as FormArray; }


  addMultipleLogs(logs) {
    // console.log("WHAT IS IN THE LOGS DATA", logs)
    if (logs && logs.length) {
      let multipleLogs = []
      logs.forEach(async (oneDayLog) => {
        await multipleLogs.push(new FormGroup({
          start: new FormControl((oneDayLog && oneDayLog.start) ? oneDayLog.start : ''),
          end: new FormControl((oneDayLog && oneDayLog.end) ? oneDayLog.end : ''),
          travel: new FormControl((oneDayLog && oneDayLog.travel) ? oneDayLog.travel : ''),
          projectCode: new FormControl((oneDayLog && oneDayLog.projectCode) ? oneDayLog.projectCode : ''),
          workingHours: new FormControl((oneDayLog && oneDayLog.workingHours) ? oneDayLog.workingHours : ''),
          totalHours: new FormControl((oneDayLog && oneDayLog.totalHours) ? oneDayLog.totalHours : ''),
          client: new FormControl((oneDayLog && oneDayLog.client) ? oneDayLog.client : ''),
        }))
      })
      this._isControlDisable = false
      return multipleLogs;
    } else {
      return [this.formBuilder.group({
        start: new FormControl(''),
        end: new FormControl(''),
        travel: new FormControl(''),
        projectCode: new FormControl(''),
        workingHours: new FormControl(''),
        totalHours: new FormControl(''),
        client: new FormControl('')
      })]
    }
  }


  addMultipleLogsforOneDay() {
    const control = <FormArray>this.jobHrsForm.controls.multipleLogs
    control.push(this.formBuilder.group({
      start: new FormControl(''),
      end: new FormControl(''),
      travel: new FormControl(''),
      projectCode: new FormControl(''),
      workingHours: new FormControl(''),
      totalHours: new FormControl(''),
      client: new FormControl('')
    }))
  }

  removeLogs(index) {
    const control = <FormArray>this.jobHrsForm.controls.multipleLogs
    control.removeAt(index)
    let totalHours = this._calculationService.calculateTotalMultipleTimelogs(this.multipleLogsList.value)
    this.jobHrsForm.patchValue({ travel: totalHours.tTraveling })
    this.countTotalWorkingHours()
  }

  changeFormValue() {
    this.jobHrsForm.valueChanges.subscribe((value) => {
      // console.log("CHANNGE FORM VALUE", value)
      this.disableMultipleLogs(value.multipleLogs)
      this.disableMultipleExpenses(value.multipleExpenses)
      this.disableMultipleDeduction(value.multipleDeduction)
      // this.calculateMultipleLogs(value.multipleLogs)
    })
  }



  get multipleExpenseList() { return this.jobHrsForm.get('multipleExpenses') as FormArray; }


  addMultipleExpenses(logs) {
    console.log("WHAT IS IN THE LOGS DATA", logs)
    if (logs && logs.length) {
      let multipleLogs = []
      logs.forEach(async (oneDayLog) => {
        await multipleLogs.push(new FormGroup({
          _id: new FormControl((oneDayLog && oneDayLog._id) ? oneDayLog._id : ''),
          expenseType: new FormControl((oneDayLog && oneDayLog.expenseType) ? oneDayLog.expenseType : ''),
          expenseAmount: new FormControl((oneDayLog && oneDayLog.expenseAmount) ? oneDayLog.expenseAmount : ''),
          expenseEvidence: new FormControl((oneDayLog && oneDayLog.expenseEvidence) ? oneDayLog.expenseEvidence : ''),
          expenseDate: new FormControl((oneDayLog && oneDayLog.expenseDate) ? oneDayLog.expenseDate : ''),
          userId: new FormControl((oneDayLog && oneDayLog.userId) ? oneDayLog.userId : ''),
        }))
      })
      this._isExpenseControlDisable = false
      return multipleLogs;
    } else {
      return [this.formBuilder.group({
        expenseType: new FormControl(''),
        expenseAmount: new FormControl(''),
        expenseEvidence: new FormControl(''),
        expenseDate: new FormControl((this.data && this.data.data) ? this._userTimeSheetServices.covertDateFormate(this.data.data.value.date, 'MM/DD/YYYY') : ''),
        userId: new FormControl(this.data.learner)
      })]
    }
  }


  addMultipleLExpense() {
    const control = <FormArray>this.jobHrsForm.controls.multipleExpenses
    control.push(this.formBuilder.group({
      expenseType: new FormControl(''),
      expenseAmount: new FormControl(''),
      expenseEvidence: new FormControl(''),
      expenseDate: new FormControl((this.data && this.data.data) ? this._userTimeSheetServices.covertDateFormate(this.data.data.value.date, 'MM/DD/YYYY') : ''),
      userId: new FormControl(this.data.learner)
    }))
  }

  removeExpense(index) {
    const control = <FormArray>this.jobHrsForm.controls.multipleExpenses
    console.log("SINGLE CONTROL VALUE", control.value[index])
    if (control.value[index] && control.value[index]._id) this.removeExpenses.push(control.value[index]._id)
    control.removeAt(index)
  }

  removeExpenseEvidence(index) {
    const control = <FormArray>this.jobHrsForm.controls.multipleExpenses
    control.controls[index].patchValue({ expenseEvidence: '' })
  }


  get multipleDeductionList() { return this.jobHrsForm.get('multipleDeduction') as FormArray; }

  addMultipleDeduction(logs) {
    console.log("WHAT IS IN THE LOGS DATA", logs)
    if (logs && logs.length) {
      let multipleLogs = []
      logs.forEach(async (oneDayLog) => {
        await multipleLogs.push(new FormGroup({
          deductionType: new FormControl((oneDayLog && oneDayLog.deductionType) ? oneDayLog.deductionType : ''),
          deductionAmount: new FormControl((oneDayLog && oneDayLog.deductionAmount) ? oneDayLog.deductionAmount : ''),
          deductionDate: new FormControl((oneDayLog && oneDayLog.deductionDate) ? oneDayLog.deductionDate : ''),
          userId: new FormControl((oneDayLog && oneDayLog.userId) ? oneDayLog.userId : ''),
        }))
      })
      this._isDeductionControlDisable = false
      return multipleLogs;
    } else {
      return [this.formBuilder.group({
        deductionType: new FormControl(''),
        deductionAmount: new FormControl(''),
        deductionDate: new FormControl((this.data && this.data.data) ? this._userTimeSheetServices.covertDateFormate(this.data.data.value.date, 'MM/DD/YYYY') : ''),
        userId: new FormControl(this.data.learner)
      })]
    }
  }


  addMultipleLDeduction() {
    const control = <FormArray>this.jobHrsForm.controls.multipleDeduction
    control.push(this.formBuilder.group({
      deductionType: new FormControl(''),
      deductionAmount: new FormControl(''),
      deductionDate: new FormControl((this.data && this.data.data) ? this._userTimeSheetServices.covertDateFormate(this.data.data.value.date, 'MM/DD/YYYY') : ''),
      userId: new FormControl(this.data.learner)
    }))
  }

  removeDeduction(index) {
    const control = <FormArray>this.jobHrsForm.controls.multipleDeduction
    console.log("SINGLE CONTROL VALUE", control.value[index])
    // if (control.value[index] && control.value[index]._id) this.removeExpenses.push(control.value[index]._id)
    control.removeAt(index)
  }



  // UTILITY FUNCATION


  // VALIDATION OF ADD MULTIPLE LOGS FOR SAME DAY
  // HERE VALIDATE ADDED TIMELOGS NOT REPEATED


  verifyMultipleLogs(formControl, index) {
    console.log("CONTROL WITH INDEX", formControl, index)
    this.selectedIndex = index
    let currentControl = this.multipleLogsList.controls[index].value
    if (this.multipleLogsList.value.length > 1) {
      let currentTime = this.getDateTime(this.jobHrsForm.get('date').value, this.multipleLogsList.controls[index].get(formControl).value)
      const checkTime = this.checkValidTime(currentTime, index)
      console.log("WHAT IS THE CURRENT CONTROL", checkTime)
      if (formControl === 'start') this._startTimeNotValid = checkTime
      if (formControl === 'end') this._endTimeNotValid = checkTime
      if (currentControl.start !== '' && currentControl.end !== '') {
        this.countTotalWorkingHours(index)
        let totalHours = this._calculationService.calculateTotalMultipleTimelogs(this.multipleLogsList.value)
        console.log("THIS IS THE TOTAL HOURS FOR ALL LOGS", totalHours)
        this.jobHrsForm.patchValue({ travel: totalHours.tTraveling })
      }
    } else {
      console.log("CURRENT CONTROL VALIE", currentControl)
      if (currentControl.start !== '' && (currentControl.end !== '')) {
        this.countTotalWorkingHours(index)
        let totalHours = this._calculationService.calculateTotalMultipleTimelogs(this.multipleLogsList.value)
        console.log("THIS IS THE TOTAL HOURS FOR ALL LOGS", totalHours)
        this.jobHrsForm.patchValue({ travel: totalHours.tTraveling })
      }
    }
  }



  calculateMultipleLogs() {
    let logs = this.multipleLogsList.value
    let lastLog = logs[logs.length - 1]
    if (lastLog.end !== '') {
      logs.forEach((log, index) => {
        console.log("THIS IS CURRENT INDEX", index)
        this.countTotalWorkingHours(index)
      })
    }

  }


  disableMultipleLogs(multipleLogs) {
    let lastLog = multipleLogs[multipleLogs.length - 1]
    if (lastLog.end !== '') this._isControlDisable = false
    else this._isControlDisable = true
  }

  disableMultipleExpenses(multipleExpenses) {
    let lastLog = multipleExpenses[multipleExpenses.length - 1]
    if (lastLog.expenseAmount !== '') this._isExpenseControlDisable = false
    else this._isExpenseControlDisable = true
  }


  disableMultipleDeduction(multipleDeduction) {
    let lastLog = multipleDeduction[multipleDeduction.length - 1]
    if (lastLog.deductionAmount !== '') this._isDeductionControlDisable = false
    else this._isDeductionControlDisable = true
  }

  close(result?) {
    this.dialogRef.close(result)
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  addTimeLogs(event) {
    console.log("event when enter something", event.target.value);
    let regex = new RegExp(/^([0-9][0-9]):[0-5][0-9]$/g)
    this.hoursValid = regex.test(event.target.value);
    if (this.hoursValid) {
      console.log("this.houursValid", this.hoursValid)
    } else {
      console.log("this is not valid");

    }
  }

  // Verify start and end time with that day other logs
  verifyStartEndTime(event, formControl, index) {
    console.log("INDEX OF CURRENT CONTROL", index)
    let regex = new RegExp(/^(?:[01][0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/)
    let currenTime
    currenTime = this.getDateTime(this.jobHrsForm.get('date').value, this.multipleLogsList.controls[index].get(formControl).value)
    console.log("WHAT IS THE CURRENT TIME", currenTime)
    if (formControl == 'start') this.startValid = regex.test(event.target.value);
    if (formControl == 'end') this.endValid = regex.test(event.target.value);
    if ((this.startValid || this.endValid) && this.data.previousDayLog && this.data.previousDayLog.length) {
      const checkTime = this.checkValidTime(currenTime, index)
      if (formControl == 'start') {
        this._startTimeNotValid = checkTime
        this.calculateTotalTime(index)
      }
      if (formControl == 'end') {
        this._endTimeNotValid = checkTime
        this.countTotalWorkingHours(index)
      }
    } else {
      if (this.endValid && this.startValid) {
        this.calculateTotalTime(index)
      }
    }
  }


  checkValidTime(currentTime, index?) {
    // const logsLength = this.data.previousDayLog.length.
    const logsLength = this.multipleLogsList.value.length
    let validTime = false
    for (let i = 0; i < logsLength; i++) {
      if (i !== index) {
        console.log("CURRENT TIME ", currentTime, i, index)
        let startTime = this.getDateTime(this.jobHrsForm.get('date').value, this.multipleLogsList.value[i].start)
        let endTime = this.getDateTime(this.jobHrsForm.get('date').value, this.multipleLogsList.value[i].end)
        console.log("WHAT IS THE START TIME", startTime, "WHAT IS THE END TIME", endTime)
        const valid = startTime <= currentTime && endTime >= currentTime
        console.log("WHAT IS THE VALID CHECK VALUE", valid)
        if (valid) validTime = valid
      }
    }
    return validTime
  }


  calculateTotalTime(index) {
    let endTime = this.multipleLogsList.controls[index].get('end').value
    if (endTime != '00:00') {
      console.log("this is for total hours");
      if (this.endValid && this.startValid) {
        this.countTotalWorkingHours(index)
      }
    }
  }

  getDateTime(date, time) {
    // console.log("Date and time for both", date, time);
    const splitTime = time.split(':')
    // const totalMinutes = (splitTime[0] > 12 ? splitTime[0] - 12 : splitTime[0]) * 60 + Number(splitTime[1])
    const totalMinutes = Number(splitTime[0] * 60) + Number(splitTime[1])
    // console.log("This is the total minutes", (splitTime[0] > 12 ? splitTime[0] - 12 : splitTime[0]) * 60, totalMinutes, splitTime);
    const finalTime = new Date(new Date(date).getTime() + totalMinutes * 60000);
    // console.log("This is the final time", finalTime);
    return finalTime
  }


  countTotalWorkingHours(index?) {


    let startTime
    let endTime

    const firstIndexValue = this.multipleLogsList.value[0]
    const lastIndexValue = this.multipleLogsList.value[this.multipleLogsList.value.length - 1]
    if (firstIndexValue.projectCode && firstIndexValue.projectCode.excludTimelog) {
      startTime = this.multipleLogsList.value[1] && this.multipleLogsList.value[1].start ? this.multipleLogsList.value[1].start : '00:00'
    } else {
      startTime = this.multipleLogsList.value[0].start
    }

    if (lastIndexValue.projectCode && lastIndexValue.projectCode.excludTimelog) {
      endTime = this.multipleLogsList.value[this.multipleLogsList.value.length - 2] && this.multipleLogsList.value[this.multipleLogsList.value.length - 2].end ? this.multipleLogsList.value[this.multipleLogsList.value.length - 2].end : '00:00'
    } else {
      endTime = this.multipleLogsList.value[this.multipleLogsList.value.length - 1].end
    }
    // const workingLogs = this.multipleLogsList.value.filter((log) => log.projectCode && !log.projectCode.excludTimelog)
    // console.log("THIS IS THE WORKING LOGS DATA", workingLogs, this.multipleLogsList.value)
    // let startTime = this.multipleLogsList.value[0].start
    // let endTime = this.multipleLogsList.value[this.multipleLogsList.value.length - 1].end
    let travelTime = '00:00'
    if (index) travelTime = this.multipleLogsList.value[index].travel
    // let startTime = this.jobHrsForm.get('start').value
    // let endTime = this.jobHrsForm.get('end').value



    var timeStart = new Date("01/01/2007 " + startTime).getHours();
    var timeEnd = new Date("01/01/2007 " + endTime).getHours();

    console.log("timestart data", timeStart)
    console.log("timeEnd data", timeEnd)



    var hourDiff = timeEnd - timeStart;
    // Here's the working fiddle http://jsfiddle.net/VnwF7/4/

    // UPDATE - to calculate if we are including the next day. Just add the following if block
    console.log("BEFORE HOUR DIFF", hourDiff)
    if (hourDiff < 0) {
      hourDiff = 24 + hourDiff;
    }
    console.log("hours diff check data", hourDiff);
    // let startHours
    // let endHours
    let startMinute = new Date("01/01/2007 " + startTime).getMinutes()
    let endMinute = new Date("01/01/2007 " + endTime).getMinutes()
    // let hoursDiff
    let minutesDiff = endMinute - startMinute
    console.log("ths is the minutes diff", minutesDiff);
    let tempHours = hourDiff * 60
    console.log("TEMP HOURS", tempHours)
    let tempMinutes = Math.abs(tempHours + minutesDiff)
    console.log("%c, Total Minutes after calculation ", "color:red", tempMinutes);
    let m = (tempMinutes % 60);
    let h = (tempMinutes - m) / 60;
    console.log("minutes", m, "hours", h);
    let diffrence = (h < 10 ? "0" : "") + h.toString() + ":" + (m < 10 ? "0" : "") + m.toString();
    // console.log("%c this is the final formate of Diff", "color: blue", diffrence);
    // this.jobHrsForm.patchValue({
    //   hoursWorked: diffrence,
    // });
    // this.multipleLogsList.controls[index].patchValue({ workingHours: diffrence })
    this.jobHrsForm.patchValue({ hoursWorked: diffrence })
    // console.log("VALUE OF ALL BOOLEANS", this.hoursValid, this.isError, this.enableSave, this.isDifference);
    this.totalHours(diffrence, 'hoursWorked', travelTime, index)
  }


  totalHours(event, control, travelTime, index) {
    if (control == 'travel') {
      let regex = new RegExp(/^([0-9][0-9]):[0-5][0-9]$/g)
      this.hoursValid1 = regex.test(event.target.value);
    } else {
      this.hoursValid1 = true
    }

    if (this.hoursValid1) {
      // console.log("CURRENT LOG INDEX", this.multipleLogsList.controls[index])
      // let hoursWorked = this.multipleLogsList.controls[index].get('workingHours').value || '00:00'
      let hoursWorked
      // if (this.jobHrsForm.get('totalHours').value === '00:00') {
      hoursWorked = this.jobHrsForm.get('hoursWorked').value || '00:00'
      let totalTime = this._calculationService.calculateTotalMultipleTimelogs(this.multipleLogsList.value)
      this.jobHrsForm.patchValue({ travel: totalTime.tTraveling })
      console.log("here to calculate data", hoursWorked, this.jobHrsForm.get('totalHours').value, this.jobHrsForm.get('hoursWorked').value);
      let travel = this.jobHrsForm.get('travel').value
      let hours = (Number(hoursWorked.split(':')[0]) + Number(travel.split(':')[0])) * 60
      let minutes = Number(hoursWorked.split(':')[1]) + Number(travel.split(':')[1])
      // console.log("total hours", hours, ':', minutes);
      let temp = minutes + hours
      // console.log("%c Total Minutes after calculation ", "color:red", tempMinutes);
      let m = (temp % 60);
      let h = (temp - m) / 60;
      console.log("m", m, "h", h);
      let diffrence = (h < 10 ? "0" : "") + h.toString() + ":" + (m < 10 ? "0" : "") + m.toString();
      console.log("%c this is the final formate of Diff", "color: blue", diffrence);
      this.jobHrsForm.patchValue({
        totalHours: diffrence,
      });
      // this.multipleLogsList.controls[index].patchValue({ totalHours: diffrence })
      console.log("total time", totalTime);
      // this.jobHrsForm.patchValue({ hoursWorked: totalTime.tWorking, totalHours: totalTime.travelWorking, travel: totalTime.tTraveling })
    }
    console.log("AFTER PATCHING THE VALUE", this.multipleLogsList.value, this.jobHrsForm.value);
  }


  cpdFiles(event) {
    console.log("event", event);
    for (let i = 0; i < event.files.length; i++) {
      event.files[i].name = this.user.name
    }
    this.cpdfiles = event.files;
    // this.files.push(event.files)
    this.enableSave = true
  }

  deletedFile(event) {
    this.openSnackBar("File deleted successfully!", "Ok");
    console.log("File Deleted Event : ", event);
    this.deletedFiles.push(event)
    console.log('this.deletedFiles', this.deletedFiles)
    let index = _.findIndex(this.files, function (o) { return o._id == event._id })
    if (index > -1) {
      this.files[index]['isDeleted'] = true;
      this.files.splice(index, 1)
    }
  }


  delete() {
    console.log("click on reset");
    this.data.deletedLog.push(this.data.data.value._id)
    this.jobHrsForm.patchValue({
      start: '00:00',
      end: '00:00',
      totalHours: '00:00',
      travel: '00:00',
      hoursWorked: '00:00',
      details1: '',
      details2: '',
      // nightAway: false,
      job: null,
      shiftInfo: ''
    });
  }

  compareJob(o1: any, o2: any): boolean {
    // console.log("COMAPARE OBJ", o1, o2);
    return o1._id === o2._id
  }


  compareProjectCode(o1: any, o2: any): boolean {
    // console.log("COMAPARE OBJ", o1, o2);
    return o1._id === o2._id
  }

  compareClient(o1: any, o2: any): boolean {
    // console.log("COMAPARE OBJ", o1, o2);
    return o1._id === o2._id
  }

  getCalculationTime(control) {
    if (control === 'start') return this.multipleLogsList.value[0].start
    if (control === 'end') return this.multipleLogsList.value[this.multipleLogsList.length - 1].end

  }


  addFileModal(index) {
    console.log("index", index);
    let obj = {
      isIncident: true,
      isMultiple: false
    }

    this._utilityServices.commonDialogBoxOpen(NewFileModalComponent, obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
      console.log("ALL FILE ADDED", fileQueue)
      if (fileQueue == undefined) return
      else {
        let item = fileQueue[0]
        let re = /(?:\.([^.]+))?$/;
        let extension = re.exec(item.Key)[1];
        console.log("THIS IS THE EXTENSTION", extension)
        let fileObj = {
          title: item.key,
          alias: item.key,
          path: item.Location,
          size: item.size,
          uploadedBy: this.user.name,
          extension: extension.toLowerCase(),
        }
        // I want to add this file into formarray with help of index 
        const control = <FormArray>this.jobHrsForm.controls.multipleExpenses
        control.at(index).patchValue({ expenseEvidence: fileObj })
        console.log("this is the control value", control.value)
      }
    })
  }


  openEvidence(item) {
    console.log("item", item);
    window.open(item.path, '_blank');
  }
  getExpenseData(expenses) {
    let expenseData = []

    expenses.forEach((expense) => {
      if (expense.expenseType !== '' || expense.expenseAmount !== '') {
        // expense.expenseDate = expense.expenseDate
        if (expense && expense._id === '') delete expense._id
        expenseData.push(expense)
      }
    })
    return expenseData
    // this.multipleExpenseList.value.filter((expense) => expense.expenseType !== '' || expense.expenseAmout !== '')

  }

  getDeductionData(data) {
    let deductionData = []
    data.forEach((item) => {
      if (item.deductionAmount !== '') {
        deductionData.push(item)
      }
    })
    return deductionData
  }

  //API CALL
  save() {
    this.loading = true
    console.log("value of jobHrsForm", this.jobHrsForm.value, this.data, this.isDifference);
    if (this.data.isInstructor) {
      let obj = {
        date: this._userTimeSheetServices.covertDateFormate(this.data.data.value.date, 'MM/DD/YYYY'),
        details: {
          extraDetails: this.jobHrsForm.value.details1,
          other: this.jobHrsForm.value.details2,
          shiftInfo: this.jobHrsForm.value.shiftInfo,
          livingAllowance: this.jobHrsForm.value.livingAllowance,
          projectCode: this.jobHrsForm.value.projectCode,
          expense: this.jobHrsForm.value.expense,
          deduction: this.jobHrsForm.value.deduction,
          payRate: this.jobHrsForm.value.payRate,
          paidHours: this.jobHrsForm.value.paidHours
        },
        hours: this.data.data.value.hours,
        minutes: this.data.data.value.minutes,
        workingHours: this.jobHrsForm.value.hoursWorked,
        _id: this.data.data.value._id,
        start: this.getCalculationTime('start'),
        end: this.getCalculationTime('end'),
        job: this.jobHrsForm.value.job,
        status: this.data.data.value.status,
        travel: this.jobHrsForm.value.travel,
        totalHours: this.jobHrsForm.value.totalHours,
        isRestLength: this.isDifference,
        multipleLogs: this.multipleLogsList.value,
        multipleExpense: this.getExpenseData(this.multipleExpenseList.value),
        multipleDeduction: this.getDeductionData(this.multipleDeductionList.value),
        removeExpenses: this.removeExpenses
      }

      // if (this.data && this.data.isFatigueLogs && obj.status === undefined) {
      //   console.log("OBJECT TO BE SEND", obj)
      //   obj['status'] = 'draft'
      // }
      let finalObj = []
      finalObj.push(obj);
      console.log("THIS IS THE MAIN DATA OF MODAL", this.data.data)
      let data
      data = {
        date: finalObj,
        deletedLog: this.data.deletedLog,
        learner: this.data.learner,
        type: this.data.type,
      }
      console.log("this is the data to be send", data);
      this._userTimeSheetServices.addTimelog(data).subscribe((res) => {
        console.log("timelog data added successfully!!!", res)
        this._utilityServices.openSnackBar("Logs added successfully!", "OK")
        this.dialogRef.close(res.data)
        this.loading = false
      }, error => {
        this.loading = false
      })
    }
    else if (this.hoursValid) {
      // if (this.data.data.updated) this.updated = true
      // else this.updated = false

      let obj = {
        date: this.data.data.value.weekStartDate,
        details: {
          extraDetails: this.jobHrsForm.value.details1,
          other: this.jobHrsForm.value.details2,
        },
        hours: this.data.data.value.hours,
        minutes: this.data.data.value.minutes,
        weekStartDate: this.data.data.value.weekStartDate,
        weekEndDate: this.data.data.value.weekEndDate,
        // weekNo: this.data.data.weekNo,
        weekNumber: this.data.data.value.weekNumber,
        workingHours: this.jobHrsForm.value.hoursWorked,
        _id: this.data.data.value._id,
        files: this.files,
        newFiles: this.cpdfiles,
        deletedFiles: this.deletedFiles,
        // updated: this.updated
      }
      // if (this.cpdfiles) {
      //   this.files.push(...this.cpdfiles)
      //   obj['files'] = this.files
      // }
      let finalObj = []
      finalObj.push(obj);

      let data
      if (this.data.jobId) {
        data = {
          date: finalObj,
          deletedLog: this.data.deletedLog,
          jobId: this.data.jobId,
          learner: this.data.learner,
          type: this.data.type
        }
      } else {
        data = {
          date: finalObj,
          deletedLog: this.data.deletedLog,
          // jobId: this.data.jobId,
          learner: this.data.learner,
          type: this.data.type
        }
      }

      console.log('finalArray===========>>>>>>', data);
      this._userTimeSheetServices.addTimelog(data).subscribe((res) => {
        console.log("timelog data added successfully!!!", res)
        this._utilityServices.openSnackBar("Logs added successfully!", "OK")
        // this.openSnackBar("Logs added successfully!", "OK")
        this.dialogRef.close(res.data)
        this.loading = false
      }, err => {
        console.log("WHAT IS THE ERROR", err)
        this.loading = false
      })
    }
    else {
      console.log("Error");
      this.isError = true
      this.hoursValid = false
      this.loading = false
    }
  }


}
